import React, { useContext, useEffect } from 'react'
import Bottombar from '../Bottombar'
import VideoPlayer from '../VideoPlayer'
// import { ApiContext } from '../../context/ApiContext';
import { useNavigate } from 'react-router-dom';
import { EventsContext } from '../../context/EventsContext';

function TvLayout() {
  const { radioData } = useContext(EventsContext);
  const navigate = useNavigate();
  useEffect(() => {
    if (!radioData) {
      navigate("/");
      window.location.reload();
    }
  }, [radioData, navigate])
  if (!radioData || !radioData.tv_stream) {
    return (
      <div className="loader-container">
        <div className="dot-wave-loader">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    );
  }
  const play = {
    fill: true,
    fluid: true,
    autoplay: true,
    controls: true,
    preload: "metadata",
    sources: [
      {
        src: radioData?.tv_stream,
        type: "application/x-mpegURL"
      }
    ]
  };
  return (
    <div style={{ backgroundColor: "black", display: "flex", justifyContent: "center", alignItems: "center", width: "100vw", height: "100vh" }}>
      <div>
        <VideoPlayer {...play} />
        <Bottombar />
      </div>
    </div>
  )
}

export default TvLayout;